<app-help-page mainVideo="organic-sources"
               [tutorials]="['data-sources-adloop', 'organic-sources']"
               [videos]="['organic-sources', 'add-an-automatic-data-source', 'add-an-analytics-data-source', 'custom-data-sources']"></app-help-page>
